"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH_L1_CATEGORIES_AND_TERMINAL_NODES_FOR_STRATEGY_MATRIX = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.SEARCH_L1_CATEGORIES_AND_TERMINAL_NODES_FOR_STRATEGY_MATRIX = (0, gql_1.gql)(`
  query SearchL1CategoriesAndTerminalNodes(
    $first: Int, 
    $productTreeId: ID!, 
    $query: String!,
    $sort: [ProductTreeNodeRelativeOrderBy!]!, 
    $searchProductTreeNodeFirst: Int!,
    $vectorWeight: Float!
  ) {
  searchProductTreeNode(productTreeId: $productTreeId, query: $query, first: $searchProductTreeNodeFirst, vectorWeight: $vectorWeight) {
    productTreeNode {
      id
      title
      ancestors(first: $first, sort: $sort) {
        edges {
          node {
            ancestor {
              id
              title
            }
          }
        }
      }
    }
    score
  }
}
`);
